import { useDispatch } from 'react-redux';
import { Loader } from 'semantic-ui-react';
import useSystemSettings from '../../hooks/useSystemSettings';
import { setEditSetting } from '../../redux/actions/clients';
import { SystemSetting } from '../../types';
import EntityData from '../Common/EntityData';
import { useEffect, useState } from 'react';
import Filters from '../Common/Filters';

type SystemSettingsProps = {
  clientId: string;
};

const SystemSettings = (props: SystemSettingsProps) => {
  const { systemSettings, isLoading } = useSystemSettings(props.clientId);
  const dispatch = useDispatch();
  const handleEdit = (setting: SystemSetting) => {
    dispatch(setEditSetting(setting, props.clientId));
  };

  const [filteredSettings, setFilteredSettings] = useState([]);

  useEffect(() => {
    setFilteredSettings(systemSettings);
  }, [systemSettings]);

  return (
    <div>
      {isLoading ? (
        <Loader />
      ) : (
        <>
          {filteredSettings && (
            <Filters
              filteredLists={filteredSettings}
              originalList={systemSettings}
              allowedParams={['Key', 'Name', 'Description', 'Value']}
              setFilteredLists={setFilteredSettings}
            />
          )}
          {filteredSettings?.map((setting) => {
            return (
              <EntityData
                key={setting.id}
                entity={setting}
                enableEdit={true}
                onEdit={() => handleEdit(setting)}
              />
            );
          })}
        </>
      )}
    </div>
  );
};

export default SystemSettings;
